import { APIResponse, APIResponseDtoImpl } from '../apiresponse';

export interface SecurityTokenResponse extends APIResponse {
    getSecurityCounter(): string;
}

export class SecurityTokenResponseDtoImpl extends APIResponseDtoImpl implements SecurityTokenResponse 
{
    private securityCounter: string;

    getSecurityCounter(): string {
        return this.securityCounter;
    }

    setSecurityCounter(securityCounter: string) {
        this.securityCounter = securityCounter;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/securitytoken/securitytokenresponse.tsx